import React, { createContext, useContext } from 'react'
import { createInstance, OptimizelyProvider as OptimizelyProviderComponent } from '@optimizely/react-sdk'
import { useABDecision } from '@/hooks/cinematics/useABDecision'

import settings from '@/settings/public'

const optimizelyClient = createInstance({ sdkKey: settings?.optimizely?.sdkKey || '' })

interface IABDecisionState {
  isApplied: boolean
}

const ABDecisionContext = createContext<IABDecisionState>({ isApplied: true })

export const useABDecisionState = () => useContext(ABDecisionContext)

interface IOptimizelyProviderProps {
  children: React.ReactNode
}

export const OptimizelyProvider: React.FC<IOptimizelyProviderProps> = ({ children }) => {
  const optimizelyKey = settings?.optimizely?.sdkKey
  const isEnabled = settings?.optimizely?.isActive

  if (!optimizelyKey || !isEnabled) {
    return (
      <ABDecisionContext.Provider value={{ isApplied: true }}>
        {children}
      </ABDecisionContext.Provider>
    )
  }

  return (
    <OptimizelyProviderComponent optimizely={optimizelyClient} timeout={500}>
      <ABDecisionCoordinator>
        {children}
      </ABDecisionCoordinator>
    </OptimizelyProviderComponent>
  )
}

const ABDecisionCoordinator: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isApplied } = useABDecision()

  return (
    <ABDecisionContext.Provider value={{ isApplied }}>
      {children}
    </ABDecisionContext.Provider>
  )
}
